import { Html } from '../_models/html';

export function HtmlSpan(props: { html: Html }) {
    return (
        <span dangerouslySetInnerHTML={{
            __html: props.html
        }}></span>
    );
}